import { serviceWorkerRegister } from './js/sw';
import { ee } from './js/eventEmitter';

import bgImage1 from './assets/images/game/road-full.svg';
import bgImage1Pt from './assets/images/game/road-pt-full.png';
import bgImage2 from './assets/images/screens/bg/grass-elements.svg';

import decorImg1 from './assets/images/decor/snow-layer-1.png';
import decorImg2 from './assets/images/decor/snow-layer-2.png';
import decorImg3 from './assets/images/decor/northern-lights/northern-lights-1.png';
import decorImg4 from './assets/images/decor/northern-lights/northern-lights-2.png';
import decorImg5 from './assets/images/decor/northern-lights/northern-lights-3.png';
import decorImg6 from './assets/images/decor/spruce-branch/spruce-branch.svg';
import decorImg7 from './assets/images/decor/blizzard/snow-1.png';
import decorImg8 from './assets/images/decor/blizzard/snow-2.png';
import decorImg9 from './assets/images/decor/snow-layer-1-mobile.png';
import decorImg10 from './assets/images/decor/snow-layer-2-mobile.png';
// import decorImg11 from './assets/images/decor/northern-lights-1-mobile.png';
// import decorImg12 from './assets/images/decor/northern-lights-2-mobile.png';
// import decorImg13 from './assets/images/decor/northern-lights-3-mobile.png';

import gameImgBg1 from './assets/images/game/back/city.svg';
import gameImgBg2 from './assets/images/game/back/stadium.svg';
import gameImgBg3 from './assets/images/game/back/clouds.svg';
import gameImgBg4 from './assets/images/game/road.svg';
import gameImgBg4Pt from './assets/images/game/road-pt.png';

import gameImgLoot1 from './assets/images/game/loot/bad-ice.png';
import gameImgLoot2 from './assets/images/game/loot/bad-roadblock.png';
import gameImgLoot3 from './assets/images/game/loot/bad-log.png';
import gameImgLoot4 from './assets/images/game/loot/bad-sled.png';
import gameImgLoot5 from './assets/images/game/loot/bad-snowflake.png';
import gameImgLoot6 from './assets/images/game/loot/bad-tree.png';
import gameImgLoot7 from './assets/images/game/loot/ball.png';
import gameImgLoot8 from './assets/images/game/loot/loot-drum.png';
import gameImgLoot9 from './assets/images/game/loot/loot-flag.png';
import gameImgLoot10 from './assets/images/game/loot/loot-slapstick.png';

import gameImgRoadside1 from './assets/images/game/roadside-objects/divide-line-1.png';
import gameImgRoadside2 from './assets/images/game/roadside-objects/divide-line-2.png';
import gameImgRoadside3 from './assets/images/game/roadside-objects/bush-1.png';
import gameImgRoadside4 from './assets/images/game/roadside-objects/bush-2.png';
import gameImgRoadside5 from './assets/images/game/roadside-objects/bush-3.png';
import gameImgRoadside6 from './assets/images/game/roadside-objects/curbstone-separator.png';
import gameImgRoadside7 from './assets/images/game/roadside-objects/curbstone-separator-mobile.png';
import gameImgRoadside8 from './assets/images/game/roadside-objects/hummock-1.png';
import gameImgRoadside9 from './assets/images/game/roadside-objects/deer.png';
import gameImgRoadside10 from './assets/images/game/roadside-objects/skis-in-snowdrift.png';
import gameImgRoadside11 from './assets/images/game/roadside-objects/sign-60.png';
import gameImgRoadside12 from './assets/images/game/roadside-objects/sign-moose.png';
import gameImgRoadside13 from './assets/images/game/roadside-objects/tree-1.png';
import gameImgRoadside14 from './assets/images/game/roadside-objects/tree-2.png';
import gameImgRoadside15 from './assets/images/game/roadside-objects/tree-3.png';
import gameImgRoadside16 from './assets/images/game/roadside-objects/tree-4.png';
import gameImgRoadside17 from './assets/images/game/roadside-objects/sled-in-snowdrift.png';
import gameImgRoadside18 from './assets/images/game/roadside-objects/stump.png';
import gameImgRoadside19 from './assets/images/game/roadside-objects/rock-1.png';
import gameImgRoadside20 from './assets/images/game/roadside-objects/rock-2.png';
import gameImgRoadside21 from './assets/images/game/roadside-objects/rock-3.png';
import gameImgRoadside22 from './assets/images/game/roadside-objects/fox.png';

import gameImgWelcome1 from './assets/images/game/welcome-objects/building-buratinovo.png';
import gameImgWelcome2 from './assets/images/game/welcome-objects/building-stavki.png';
import gameImgWelcome3 from './assets/images/game/welcome-objects/building-ultraslavl.png';
import gameImgWelcome4 from './assets/images/game/welcome-objects/lake.png';
import gameImgWelcome5 from './assets/images/game/welcome-objects/sign-buratinovo.png';
import gameImgWelcome6 from './assets/images/game/welcome-objects/sign-penalti.png';
import gameImgWelcome7 from './assets/images/game/welcome-objects/sign-gadalovo.png';
import gameImgWelcome8 from './assets/images/game/welcome-objects/sign-ofsaydino.png';
import gameImgWelcome9 from './assets/images/game/welcome-objects/sign-stavki.png';
import gameImgWelcome10 from './assets/images/game/welcome-objects/sign-ultraslavl.png';

const progress = {
    value: 0,
    preloaderEl: document.getElementById('preloader'),
    progressValueElement: document.getElementById('progressValue'),

    get progressValue() {
        return this.value;
    },

    set progressValue(val) {
        this.value = val;
        this.progressValueElement.innerHTML = Math.round(val).toString(10);
    }
};

const loadResources = async () => {
    const srcImagesForPreload = [
        bgImage1,
        bgImage1Pt,
        bgImage2,
        //
        //
        decorImg1,
        decorImg2,
        decorImg3,
        decorImg4,
        decorImg5,
        decorImg6,
        decorImg7,
        decorImg8,
        decorImg9,
        decorImg10,
        // decorImg11,
        // decorImg12,
        // decorImg13,
        //
        gameImgBg1,
        gameImgBg2,
        gameImgBg3,
        gameImgBg4,
        gameImgBg4Pt,
        //
        gameImgLoot1,
        gameImgLoot2,
        gameImgLoot3,
        gameImgLoot4,
        gameImgLoot5,
        gameImgLoot6,
        gameImgLoot7,
        gameImgLoot8,
        gameImgLoot9,
        gameImgLoot10,
        //
        gameImgRoadside1,
        gameImgRoadside2,
        gameImgRoadside3,
        gameImgRoadside4,
        gameImgRoadside5,
        gameImgRoadside6,
        gameImgRoadside7,
        gameImgRoadside8,
        gameImgRoadside9,
        gameImgRoadside10,
        gameImgRoadside11,
        gameImgRoadside12,
        gameImgRoadside13,
        gameImgRoadside14,
        gameImgRoadside15,
        gameImgRoadside16,
        gameImgRoadside17,
        gameImgRoadside18,
        gameImgRoadside19,
        gameImgRoadside20,
        gameImgRoadside21,
        gameImgRoadside22,
        //
        gameImgWelcome1,
        gameImgWelcome2,
        gameImgWelcome3,
        gameImgWelcome4,
        gameImgWelcome5,
        gameImgWelcome6,
        gameImgWelcome7,
        gameImgWelcome8,
        gameImgWelcome9,
        gameImgWelcome10
    ];

    const imagesForPreload = srcImagesForPreload.map(() => new Image());

    const preloaderStep = 100 / imagesForPreload.length;

    const promiseArray = imagesForPreload.map((image, index) => new Promise((resolve) => {
        const handler = () => {
            if (progress.value === 0) {
                progress.preloaderEl.classList.add('numbers-visible');
            }

            progress.progressValue += preloaderStep;
            resolve();
        };

        image.onload = handler;
        image.onerror = handler;

        image.src = srcImagesForPreload[index];
    }));

    await Promise.all(promiseArray);
};

const loadDone = async () => {
    if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
        serviceWorkerRegister();
    }

    // eslint-disable-next-line
    await new Promise((resolve) => setTimeout(resolve, 500));

    ee.emit('htmlLoaded');
    await loadResources();

    ee.emit('loadDone');
};

export default () => {
    window.addEventListener('load', loadDone);
};
